/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsempty1Inputs */

const en_ticketsempty1 = /** @type {(inputs: Ticketsempty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sell tickets for this event right on Pulsify, free or paid.`)
};

const de_ticketsempty1 = /** @type {(inputs: Ticketsempty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkaufe Tickets für dieses Event direkt über Pulsify, kostenlos oder bezahlt.`)
};

/**
* | output |
* | --- |
* | "Sell tickets for this event right on Pulsify, free or paid." |
*
* @param {Ticketsempty1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsempty1 = /** @type {((inputs?: Ticketsempty1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsempty1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsempty1(inputs)
	return de_ticketsempty1(inputs)
});
export { ticketsempty1 as "ticketsEmpty" }